/**
 * 协议确认记录上报工具
 * 各端（乘客/司机/渠道/管理员）在用户确认协议后调用
 */

/**
 * 用户类型常量
 */
export const USER_TYPE = {
  PASSENGER: 1,
  DRIVER: 2,
  CHANNEL: 3,
  ADMIN: 4,
}

/**
 * 上报协议确认记录
 * @param {Object} axiosInstance - Vue 实例中的 $axios
 * @param {Object} params
 * @param {string} params.appKey
 * @param {number} params.agreementId - 协议ID
 * @param {number} params.userType - 用户类型（USER_TYPE 常量）
 * @param {number} params.userId - 用户ID
 * @param {string} [params.userName] - 用户姓名
 * @returns {Promise}
 */
export async function confirmProtocol(axiosInstance, params) {
  try {
    const data = {
      appKey: params.appKey,
      agreementId: params.agreementId,
      userType: params.userType,
      userId: params.userId,
      userName: params.userName || '',
    }
    return await axiosInstance.post('/api/v1/common/protocol/confirm', data)
  } catch (e) {
    console.warn('[ProtocolConfirm] 上报失败，不影响主流程', e)
    return null
  }
}
